import { render, staticRenderFns } from "./branch_shop.vue?vue&type=template&id=4599ed32&scoped=true&"
import script from "./branch_shop.vue?vue&type=script&lang=js&"
export * from "./branch_shop.vue?vue&type=script&lang=js&"
import style0 from "./branch_shop.vue?vue&type=style&index=0&lang=css&"
import style1 from "./branch_shop.vue?vue&type=style&index=1&id=4599ed32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4599ed32",
  null
  
)

export default component.exports